import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import Vuetify from "vuetify";
import vuetify from "@/plugins/vuetify.js";
import routes from "./router/routes.js";

import VueKatex from "vue-katex";
import "katex/dist/katex.min.css";

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(VueKatex);

import store from "./store/index.js";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active"
});

//import PaperDashboard from "./plugins/paperDashboard.js";
//import "vue-notifyjs/themes/default.css";

//Vue.config.productionTip = false;
//Vue.use(PaperDashboard);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
